import { QURAN_DATA_VERSION } from '../config/quranDataVersion';

/**
 * Prefix for all localStorage/sessionStorage keys that mirror static JSON / API-shaped data.
 * Changing REACT_APP_QURAN_DATA_VERSION invalidates them via migrateQuranCacheOnVersionChange.
 */
export function quranDataKey(name) {
  return `qdv${QURAN_DATA_VERSION}:${name}`;
}
